import { formatNumber } from '@angular/common';
import {
  DEFAULT_UNIT_PRECISION_MAP,
  resolveUnitPrecision,
  UnitPrecisionMap,
  UnitPrecisionOverrides
} from './unit-precision.helper';

/** Formats display values only; callers must retain the original numeric value for saving and matching. */
export function formatUnitNumber(
  value: number | null | undefined,
  unit: string | null | undefined,
  locale = 'en-US',
  precisionMap: UnitPrecisionMap = DEFAULT_UNIT_PRECISION_MAP,
  precisionOverrides: UnitPrecisionOverrides = {}
): string {
  if (value == null) {
    return '';
  }

  const decimals = resolveUnitPrecision(unit, precisionMap, precisionOverrides);
  return formatNumber(value, locale, `1.0-${decimals}`);
}
